import { createStateSelectorHook } from 'src/lib/sweetState';

import { Store } from './store';

const useStoreState = createStateSelectorHook(Store, [
  'projects',
  'hasNextPage',
  'loading',
  'loadingMore',
  'error',
  'loadMoreError',
]);

export const useViewState = () => {
  const storeState = useStoreState();
  return { ...storeState };
};
